"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _cookies = require("@kiwicom/cookies");
var _context = require("../../services/intl/context");
var _context2 = require("../../services/currency/context");
var _context3 = require("../../services/auth/context");
var _updateLocale = _interopRequireDefault(require("../../graphql/account/queries/updateLocale"));
var _updateLanguagePath = _interopRequireDefault(require("./updateLanguagePath"));
var _context4 = require("../TopNav/services/context");
var _context5 = require("../../services/log/context");
var _events = require("../../consts/events");
var _MarketCurrencySelector = _interopRequireDefault(require("./MarketCurrencySelector"));
var _Market = require("../../records/Market");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RegionalSettings = _ref => {
  let {
    onClose,
    brandLanguage,
    triggerRef
  } = _ref;
  const {
    language
  } = (0, _context.useIntl)();
  const {
    onSaveRegionalSettings
  } = (0, _context4.useNavConfig)();
  const {
    onChange,
    currency
  } = (0, _context2.useCurrency)();
  const getAccessToken = (0, _context3.useGetAccessToken)();
  const {
    log
  } = (0, _context5.useLog)();
  const isLoggedIn = (0, _context3.useIsLoggedIn)();
  const [marketId, setMarketId] = React.useState((0, _cookies.load)(_cookies.Cookie.KW_USER_MARKET) || _Market.marketDefault.id);
  const languageMap = brandLanguage.languages;
  const onMarketChange = marketId => {
    (0, _cookies.save)(_cookies.Cookie.KW_USER_MARKET, marketId);

    // FE Booking uses custom onSaveLang function to persist form data
    // on page refresh
    if (onSaveRegionalSettings) {
      onSaveRegionalSettings({
        languageId: language.id,
        currencyId: currency.id,
        marketId
      });
      onClose();
      return;
    }
    setMarketId(marketId);
  };
  const onLanguageChange = async languageId => {
    if (isLoggedIn) {
      var _languageMap$language;
      const languageIso = (_languageMap$language = languageMap[languageId]) === null || _languageMap$language === void 0 ? void 0 : _languageMap$language.iso;
      try {
        const accessToken = await getAccessToken();
        if (accessToken) {
          await (0, _updateLocale.default)(accessToken, {
            currency: currency.id.toUpperCase(),
            language: {
              code: languageIso
            }
          });
        }
      } catch (err) {
        log(_events.REGIONAL_SETTINGS_ERROR, {
          error: String(err),
          currency: currency.id,
          language: languageIso,
          market: marketId
        });
      }
    }
    (0, _cookies.save)(_cookies.Cookie.LANGUAGE, languageId);
    // FE Booking uses custom onSaveLang function to persist form data
    // on page refresh
    if (onSaveRegionalSettings) {
      onSaveRegionalSettings({
        languageId,
        currencyId: currency.id,
        marketId
      });
      onClose();
      return;
    }
    (0, _updateLanguagePath.default)(languageId);
  };
  const onCurrencyChange = async currencyId => {
    if (isLoggedIn) {
      var _languageMap$language2;
      const languageIso = (_languageMap$language2 = languageMap[language.id]) === null || _languageMap$language2 === void 0 ? void 0 : _languageMap$language2.iso;
      try {
        const accessToken = await getAccessToken();
        if (accessToken) {
          await (0, _updateLocale.default)(accessToken, {
            currency: currencyId.toUpperCase(),
            language: {
              code: languageIso
            }
          });
        }
      } catch (err) {
        log(_events.REGIONAL_SETTINGS_ERROR, {
          error: String(err),
          currency: currencyId,
          language: languageIso,
          market: marketId
        });
      }
    }
    (0, _cookies.save)(_cookies.Cookie.CURRENCY, currencyId);
    onChange(currencyId);
    if (onSaveRegionalSettings) {
      onSaveRegionalSettings({
        languageId: language.id,
        currencyId,
        marketId
      });
    }
    onClose();
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MarketCurrencySelector.default, {
    market: marketId,
    language: language.id,
    currency: currency.id,
    onCurrencyChange: onCurrencyChange,
    onLanguageChange: onLanguageChange,
    onMarketChange: onMarketChange,
    onClose: onClose,
    triggerRef: triggerRef
  });
};
var _default = exports.default = RegionalSettings;